/* eslint-disable react-refresh/only-export-components --
   Dev-only tooling: the exports are `import.meta.env.DEV ? ... : ...` ternaries
   the rule can't recognize as components, and fast refresh is irrelevant for
   devtool panels. */
import React, { Suspense } from "react";

const NullDevTool = (): null => null;

/**
 * Dev-only tooling. Gated on `import.meta.env.DEV` so production/staging
 * builds tree-shake the lazy imports and never mount these panels.
 */
export const ReactHookFormDevelopmentTools = import.meta.env.DEV
  ? (() => {
      const LazyDevTool = React.lazy(() =>
        import("@hookform/devtools")
          .then((result) => ({
            default: result.DevTool,
          }))
          .catch(() => ({ default: NullDevTool }))
      );

      const ReactHookFormDevTool = (props: React.ComponentProps<typeof LazyDevTool>) => (
        <Suspense fallback={null}>
          <LazyDevTool {...props} />
        </Suspense>
      );
      return ReactHookFormDevTool;
    })()
  : NullDevTool;

export const TanStackRouterDevelopmentTools = import.meta.env.DEV
  ? (() => {
      const LazyDevTool = React.lazy(() =>
        import("@tanstack/router-devtools")
          .then((result) => ({
            default: result.TanStackRouterDevtools,
          }))
          .catch(() => ({ default: NullDevTool }))
      );

      const TanStackRouterDevTool = (props: React.ComponentProps<typeof LazyDevTool>) => (
        <Suspense fallback={null}>
          <LazyDevTool {...props} />
        </Suspense>
      );
      return TanStackRouterDevTool;
    })()
  : NullDevTool;

export const TanStackReactQueryDevelopmentTools = import.meta.env.DEV
  ? (() => {
      const LazyDevTool = React.lazy(() =>
        import("@tanstack/react-query-devtools")
          .then((result) => ({
            default: result.ReactQueryDevtools,
          }))
          .catch(() => ({ default: NullDevTool }))
      );

      const TanStackReactQueryDevTool = (props: React.ComponentProps<typeof LazyDevTool>) => (
        <Suspense fallback={null}>
          <LazyDevTool {...props} />
        </Suspense>
      );
      return TanStackReactQueryDevTool;
    })()
  : NullDevTool;
